import * as React from 'react';
import { IRgrCertificateProps, AgentType } from '.';
import { stopPropagation } from './utils';
import * as styles from './styles.css';

export const RgrTooltip = ({ type }: IRgrCertificateProps) => {
  const title = `${type === AgentType.Realtor ? 'Агент' : 'Агентство'} входит в РГР`;
  const subtitle = `Стандарты качества услуг ${
    type === AgentType.Realtor ? 'агента' : 'компании'
  } сертифицированы, деятельность застрахована`;

  return (
    <div className={styles['container']} onClick={stopPropagation}>
      <h4 className={styles['title']}>{title}</h4>
      <a
        className={styles['link']}
        href="https://hc.cian.ru/hc/ru/articles/4409480755348"
        target="_blank"
        rel="noreferrer"
      >
        Подробнее
      </a>
      <div>{subtitle}</div>
    </div>
  );
};
